import React from 'react';

const ToastSuccess = msg => {
  return (
    <div className="toast-inner success">
      <span className="toast-message">{msg}</span>
    </div>
  );
};

export default ToastSuccess;
